<template>
  <div class="population-component">
    <p class="title">population</p>
    <div class="select">
      <select v-model="$data.selectedType" :style="{ backgroundImage: `url('${_selectArrowSrc}')` }">
        <template v-for="(option, index) in _optionsIncludeAll">
          <option :key="`optionIncludeAll-${index}`" :value="option.value">
            {{ option.name }}
          </option>
        </template>
      </select>
    </div>

    <template v-if="$data.selectedType === 'all'">
      <template v-for="(option, index) in _optionsExcludeAll">
        <div :key="`optionExcludeAll-${index}`" class="rate">
          {{ rate(option.value) }}
        </div>
      </template>
    </template>

    <template v-else>
      <div class="rate">
        {{ _rate }}
      </div>

      <div class="rate">
        {{ _inputBirthRate }}
      </div>

      <div class="rate">
        {{ _inputDeathRate }}
      </div>

      <div class="rate">output birth_rate: {{ _outputBirthRate.birthRate }} {{ _outputBirthRate.reason }}</div>

      <div class="rate">
        {{ _outputDeathRate }}
      </div>
    </template>
  </div>
</template>

<script>
import CONSTANS from '@/constants/index.js';
import _ from 'lodash';
import SELECT_ARROW from '../../assets/images/select-arrow.svg';

export default {
  props: {
    lifeDeathRatios: Object,
    agents: Array,
  },
  data() {
    return {
      selectedType: 'all',
    };
  },
  computed: {
    _optionsIncludeAll() {
      return CONSTANS.AGENT_TYPES_FOR_POPULATION;
    },
    _optionsExcludeAll() {
      return CONSTANS.AGENT_TYPES;
    },
    _rate() {
      const selectedType = this.$data.selectedType;
      const typeInfo = this.findFromTypeMap(selectedType);
      const population = this.agentPopulation(typeInfo);

      return `${selectedType}: ${population.number}, max(${typeInfo.max}), ${
        population.percentage === 0 ? '0.000' : population.percentage
      }%`;
    },
    _inputBirthRate() {
      return `input birth_rate: ${this.$props.lifeDeathRatios[`${this.$data.selectedType}`].birthRate}%`;
    },
    _inputDeathRate() {
      return `input death_rate: ${this.$props.lifeDeathRatios[`${this.$data.selectedType}`].deathRate}%`;
    },
    _outputBirthRate() {
      const selectedType = this.$data.selectedType;
      const isAgentOne = selectedType === 'agent_1';

      // 一つしたのagentの内容を元に算出する関係上、targetは-1したagent
      const targetType = (() => {
        if (isAgentOne) {
          return 'agent_1';
        }

        // agent_XのXだけ抜き出し数字型にする
        const number = parseInt(selectedType.split('_')[1], 10);

        return `agent_${number - 1}`;
      })();

      const targetTypeInfo = this.findFromTypeMap(targetType);
      const targetPopulation = this.agentPopulation(targetTypeInfo);
      const condition = CONSTANS.BIRTH_CONDITION[`${selectedType}`];

      // 条件をクリアしているかどうか（agent_1はnullと比較するので、自然）
      const isReadyToBirth = (() => {
        if (isAgentOne) {
          return true;
        }

        return (
          targetTypeInfo.max * condition.min <= targetPopulation.number &&
          targetPopulation.number <= targetTypeInfo.max * condition.max
        );
      })();

      // 条件クリアしていなければ生まれない。
      const birthRate = isReadyToBirth ? `${this.$props.lifeDeathRatios[`${selectedType}`].birthRate}%` : '0.000%';

      const reason = (() => {
        // 条件クリアしていたら空
        if (isReadyToBirth) {
          return '';
        }

        // 条件未満の場合
        if (targetPopulation.number < targetTypeInfo.max * condition.min) {
          const diff = condition.min * 100 - targetPopulation.percentage;

          return `( ${targetType} population: ${_.round(diff, 3)}% less )`;
        }

        // 条件より多い場合
        if (targetTypeInfo.max * condition.max < targetPopulation.number) {
          const diff = targetPopulation.percentage - condition.max * 100;

          return `( ${_.round(diff, 3)}% more ${targetType} for emerging )`;
        }
      })();

      return {
        isReadyToBirth,
        birthRate,
        reason,
      };
    },
    _outputDeathRate() {
      return `output death_rate: ${this.$props.lifeDeathRatios[`${this.$data.selectedType}`].deathRate}%`;
    },
    _selectArrowSrc() {
      return SELECT_ARROW;
    },
  },
  methods: {
    agentPopulation(typeInfo) {
      const resultArray = this.$props.agents.filter((agent) => {
        return agent.type === typeInfo.name;
      });

      const resultPopulation = resultArray.length;
      const resultPercentage = (resultArray.length / typeInfo.max) * 100;

      return {
        number: resultPopulation,
        percentage: resultPercentage !== 0 ? _.round(resultPercentage, 3) : 0.0,
      };
    },
    findFromTypeMap(type) {
      const result = CONSTANS.TYPE_MAP.find((item) => {
        return item.name === type;
      });

      return result;
    },
    rate(type) {
      const typeInfo = this.findFromTypeMap(type);
      const population = this.agentPopulation(typeInfo);

      return `${type}: ${population.number}, max(${typeInfo.max}), ${
        population.percentage === 0 ? '0.000' : population.percentage
      }%`;
    },
  },
};
</script>

<style lang="scss" scoped>
.population-component {
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  align-items: flex-end;

  @include spLandscape {
    position: fixed;
    right: 23px;
    bottom: 20px;
  }

  p {
    margin-bottom: 13px;
    text-align: end;
    font-size: 10px;
    letter-spacing: 1px;
    color: #070751;
  }
}

.title {
  font-weight: 500;
  margin-bottom: 15px;
}

.select {
  width: 160px;
}

select {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  padding-left: 10px;
  border: none;
  background-repeat: no-repeat;
  background-size: 8px 9px;
  background-position: right 10px center;
  background-color: #fff;

  height: 24px;
  width: 100%;
  border: 1px solid rgba(7, 7, 81, 0.6);
  color: #070751;
  border-radius: 2px;
  font-size: 10px;
  letter-spacing: 1px;

  cursor: pointer;
  transition: all 0.1s cubic-bezier(0.32, 0.625, 0.58, 1);

  &::-ms-expand {
    display: none;
  }

  &:focus {
    outline: none;
  }

  &:hover {
    border: 1px solid rgba(7, 7, 81, 1);
  }
}

.rate {
  margin-top: 13px;
  text-align: end;
  font-size: 10px;
  letter-spacing: 1px;
  color: #070751;

  @include sp {
    margin-top: 16px;
  }
}
</style>
